/* eslint-disable react/no-unused-state */
/* eslint-disable react/no-array-index-key */
/* eslint-disable jsx-a11y/label-has-associated-control */
/* eslint-disable max-len */
/* eslint-disable jsx-a11y/anchor-is-valid */
import React from 'react';

import { I18n } from 'react-redux-i18n';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import PanelSidebar from '../components/panel/PanelSidebar';
import { appendScript, removeScript, scrollToTopAnimated } from '../components/utils';

import { history } from '../routers/AppRouter';

import {
  cartsGetSolicitationsList, cartRequesterCancelOrder,
} from '../app/store/actions/cart';

import PriceTaxComponent from '../components/price/PriceTax';
import ROUTES from '../data/routes';

class MySolicitationsPage extends React.PureComponent {
  constructor(props) {
    super(props);

    this.state = {
      showModalCancelOrder: false,
      reasonForCancellationDisabled: true,
      cart: null,
      observation: '',
      carts: [],
    };
  }

  componentDidMount = () => {
    setTimeout(async () => {
      if (this.props.purchasePermission && !this.props.limit) {
        history.push(ROUTES.HOME);
        return;
      }

      await this.loadCarts();

      removeScript('/scripts/panel.min.js');
      appendScript('/scripts/panel.min.js');

      scrollToTopAnimated();
    }, 0);
  }

  componentWillUnmount = () => {
    removeScript('/scripts/panel.min.js');
  }

  loadCarts = async () => {
    const carts = await this.props.getCarts();
    await this.setState({ carts });
  };

  setValue = async (e) => {
    let { reasonForCancellationDisabled } = this.state;
    reasonForCancellationDisabled = !e.target.value;

    await this.setState({ observation: e.target.value, reasonForCancellationDisabled });
  };

  cancelOrder = async () => {
    const { cart = {}, observation } = this.state;
    this.setState({ showModalCancelOrder: false, cart: null });

    const approversEmail = [];
    cart.approvers.forEach(approver => (approversEmail.push(approver.email)));

    await this.props.cartRequesterCancelOrder(cart.cartId, observation, approversEmail);
    await this.loadCarts(null);
  };

  renderCartReproveModal = (showModalCancelOrder) => {
    const { observation, reasonForCancellationDisabled } = this.state;
    return (
      <div
        className="modal"
        style={{ display: showModalCancelOrder ? 'block' : 'none' }}
        role="presentation"
      >
        <div className="modal-content">
          <div className="modal-body">
            <div className="column body-modal-text">
              <h3 className="h3-modal-div">{I18n.t('cancelOrderConfirm')}</h3>
              <div className="_reason-cancel-order">
                <input
                  className="reason"
                  type="text"
                  placeholder={I18n.t('reasonCancelOrder')}
                  value={observation}
                  onChange={e => this.setValue(e)}
                />
              </div>
            </div>
            <div className="row body-modal-div">
              <button
                type="button"
                className="btn"
                onClick={() => this.setState({ showModalCancelOrder: false, cart: null })}
              >
                {I18n.t('cancel')}
              </button>
              <button
                type="button"
                className="btn"
                onClick={() => this.cancelOrder()}
                style={{ backgroundColor: '#b93744' }}
                disabled={reasonForCancellationDisabled}
              >
                {I18n.t('cancelOrder')}
              </button>
            </div>
          </div>
        </div>
      </div>
    );
  }

  approversColumns = (approver) => {
    const {
      email, status, i,
    } = approver;
    let {
      date,
    } = approver;

    date = date ? moment(date).format('DD/MM/YYYY') : '';
    return (
      <div className="_columns _approver">
        <div className="_labels">
          {I18n.t('approver')}
          {' '}
          {i}
          {' '}
          {/* 'i' É o indice, para mostrar se aprovador 1 ou 2 */}
          :
        </div>
        <div className="_dates">
          {date}
        </div>
        <div className="_responsibles">
          {email}
        </div>
        <div className="_status">
          {I18n.t(status)}
        </div>
      </div>
    );
  }

  renderCartsToApproveCart = ({
    key,
    cart = {},
    pricePermission,
  }) => {
    const {
      products = [], cartId, createdAt, user, approvers,
    } = cart;

    const date = moment(createdAt);
    const day = date.format('DD');
    const month = date.format('MMM').toLocaleUpperCase();
    const year = date.format('YYYY');

    return (
      <div className="requests-item" key={key}>
        <div className="date">
          <div className="card_info">
            <div className="card_info_item card_info_date">
              <p className="_info_date">
                <strong>
                  {day}
                  {' '}
                  |
                  {' '}
                  {month}
                  {' '}
                  |
                  {' '}
                  {year}
                  {' '}
                </strong>
              </p>
              {' '}
              {/* <span className="line" /> */}
            </div>
            <div className="card_info_item card_info_cart_code">
              <strong>{I18n.t('cartNumber')}</strong>
              {' '}
              {cartId}
              <span className="line" />
              {/* {' '} */}
            </div>
            <div className="card_info_item card_info_status">
              <strong>
                {I18n.t('cartStatus')}
              </strong>
              {' '}
              {I18n.t('pendingApproval')}
              <span className="line" />
            </div>
          </div>
        </div>
        <div className="content">
          <div className="content-cart-item">
            <div className="_items">
              <div className="_columns _headers">
                <div className="_labels">
                  {' '}
                </div>
                <div className="_dates">
                  <strong>
                    {I18n.t('dates')}
                  </strong>
                </div>
                <div className="_responsibles">
                  <strong>
                    {I18n.t('responsibles')}
                  </strong>
                </div>
                <div className="_status">
                  <strong>
                    {I18n.t('status')}
                  </strong>
                </div>
              </div>
              <div className="_columns _requester">
                <div className="_labels">
                  <strong>
                    {I18n.t('requester')}
                    :
                  </strong>
                </div>
                <div className="_dates">
                  {date.format('DD/MM/YYYY')}
                </div>
                <div className="_responsibles">
                  {user.email}
                </div>
                <div className="_status">
                  <strong>
                    #
                  </strong>
                </div>
              </div>
              { approvers && approvers.map(approver => (this.approversColumns(approver))) }
            </div>

          </div>
          <div className="content-footer">
            <div className="btns">
              <button
                type="button"
                className="btn btn-grey _btn-cancel-order"
                onClick={() => this.setState({ cart, showModalCancelOrder: true })}
              >
                {I18n.t('cancelOrder')}
              </button>
            </div>
            {pricePermission && <PriceTaxComponent products={products} />}
          </div>
        </div>
      </div>
    );
  };

  render() {
    const {
      carts = [],
      showModalCancelOrder,
    } = this.state;
    const { pricePermission, purchasePermission, limit } = this.props;

    if (purchasePermission && !limit) {
      return (
        <main>
          <div style={{ height: '50vh' }} />
        </main>
      );
    }

    return (
      <main>
        <div className="section section-panel">
          <div className="container">
            <h1 className="panel-title">{I18n.t('mySolicitations2')}</h1>

            <div className="panel-content">

              <PanelSidebar />

              <div className="box-content requests">

                {carts.map(cart => this.renderCartsToApproveCart({
                  key: cart.cartId,
                  cart,
                  pricePermission,
                }))}

              </div>

            </div>

          </div>

          {this.renderCartReproveModal(showModalCancelOrder)}
        </div>
      </main>
    );
  }
}

const mapDispatchToProps = dispatch => ({
  getCarts: () => dispatch(cartsGetSolicitationsList()),
  cartRequesterCancelOrder: (cartId, observation, approversEmail) => dispatch(cartRequesterCancelOrder(cartId, observation, approversEmail)),
});

const mapStateToProps = state => ({
  pricePermission: state.contracts.selected && state.contracts.selected.pricePermission,
  purchasePermission: state.contracts.selected && state.contracts.selected.purchasePermission,
  limit: state.contracts.selected && state.contracts.selected.limit,
});

export default connect(mapStateToProps, mapDispatchToProps)(MySolicitationsPage);
